var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(!_vm.error)?_c('loader'):_c('errors',{attrs:{"errorNetworkrErrorprops":this.networkError,"error401props":this.error401,"error500props":this.error500,"errorOtherprops":this.errorOther}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }